import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { useEffect, useMemo, useState } from 'react';
import { withOverlay } from '../common/withOverlay';
import { Image } from './image';
import styles from './image.module.scss';
const ImageOverlayComponent = ({ src, isClosing, height = 0, width = 0, loaderSize = 'sm', }) => {
    const [docWidth, docHeight] = [
        Math.round(document.body.clientWidth * 0.9),
        Math.round(document.body.clientHeight * 0.9),
    ];
    const [canShow, setCanShow] = useState(false);
    const overlayClass = useMemo(() => {
        return classNames(styles.image_overlay, {
            [styles.image_overlay_close]: isClosing,
            [styles.image_overlay_open]: canShow,
        });
    }, [isClosing, canShow]);
    useEffect(() => {
        setTimeout(() => setCanShow(true), 100);
    }, []);
    return (_jsx("div", { className: overlayClass, children: _jsx(Image, { src: src, width: Math.min(docWidth, width), height: Math.min(docHeight, height), isOverlay: true, loaderSize: loaderSize }) }));
};
const ImageOverlay = withOverlay(ImageOverlayComponent, {
    backdropColor: 'rgba(0,0,0,0.85)',
    name: 'imageOverlay',
});
export { ImageOverlayComponent };
export { ImageOverlay };
